const PasswordChecklistConfig = {
  minLength: "Password should include at least 8 characters",
  specialChar: "Password should include at least 1 special character",
  number: "Password should include at least 1 number",
  capital: "Password should include at least 1 capital letter"
};

export default PasswordChecklistConfig;
